let buttonNotif = document.getElementById('alert-close')

if(buttonNotif) {
    buttonNotif.addEventListener('click', function() {
        console.log('test');
        document.querySelector('.leo-alert-success').classList.remove('show')
    })
}